import React, { useEffect, useState } from 'react'
import TopNavigation from '../Components/navigation/TopNavigation'
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import MainFooter from '../Components/footer/MainFooter';

function ThankYou() {
    const {user}                                                   = useSelector((state) => state.auth);

  return (
    <div className="main-layer">
        <TopNavigation title={"Payment Successful"} classBack="full-white"/>
        <div className="content-layer">
           
             <div className="section-item">             
                <div className="container">
                  <div className="short-style-banner">
                    <div className="head-container-widget">
                      <h2>Thank you for your log in.</h2>
                      <div className="sub-head-widget">
                      Enjoy going through our most elegant of services.
                      </div>
                    </div>
                  </div>
                    <div className="place-middle mgtop30 pd10 text-center row">
                      <div className="col-md-6">
                          
                          <h4>
                            Take a look at our latest wedding invitations or create one yourself.
                          </h4>
                          <Link to={"/onsites"} className="btn btn-main">
                            Onsites
                          </Link>
                      </div>

                       <div className="col-md-6">
                         <h4>
                          Take a loook at our anniversaries.
                         </h4>
                          <Link to={"/annisites"} className="btn btn-main">
                            Annisites
                          </Link>
                       </div>
                    </div>

                </div>
            </div>
        </div>
        <MainFooter />
    </div>
  )
}

export default ThankYou